import {
    SET_GARMIN_CONNECT_INSTALLED,
    SET_GARMIN_KNOWN_DEVICES,
    SET_GARMIN_SELECTED_DEVICE,
} from "../actions/types";
import { GarminWatches } from "../models/refsixState";

const initialState: GarminWatches = {
    knownDevices: [],
    selectedDevice: undefined,
};

export const garminReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_GARMIN_KNOWN_DEVICES:
            return {
                ...state,
                knownDevices: action.devices,
            };
        case SET_GARMIN_SELECTED_DEVICE:
            return {
                ...state,
                selectedDevice: action.device,
            };
        case SET_GARMIN_CONNECT_INSTALLED:
            return {
                ...state,
                isConnectInstalled: action.isConnectInstalled,
            };
        default:
            return state;
    }
};
